import { makeStyles } from '@material-ui/styles'
import React, { FC, ReactElement } from 'react'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import AsyncDropdown, { AsyncDropdownProps } from './AsyncDropdown'

interface DropdownFieldWithComingSoonProps<V> extends AsyncDropdownProps<V> {
  comingSoon?: boolean
  id?: string
}

const DropdownFieldWithComingSoon = React.forwardRef(function DropdownFieldWithComingSoon<V>(
  { comingSoon = false, id, ...props }: DropdownFieldWithComingSoonProps<V>,
  ref,
) {
  const classes = useStyles()

  return (
    <div className={classes.wrapper}>
      {comingSoon && (
        <Text
          variant="caption1"
          className={`${classes.comingSoonFlag} coming-soon`}
          aria-label="This feature is coming soon"
        >
          Coming soon!
        </Text>
      )}
      <AsyncDropdown<V> {...(props as AsyncDropdownProps<V>)} disabled={comingSoon} id={id} />
    </div>
  )
}) as <V = string>(
  props: DropdownFieldWithComingSoonProps<V> & { ref?: React.Ref<any> },
) => ReactElement<DropdownFieldWithComingSoonProps<V>>

export default DropdownFieldWithComingSoon

const useStyles = makeStyles<Theme>((theme) => ({
  wrapper: {
    position: 'relative',
  },
  comingSoonFlag: {
    position: 'absolute',
    top: theme.spacing(4.8),
    right: 0,
    backgroundColor: theme.palette.blue['700'],
    color: theme.palette.common.white,
    padding: theme.spacing(0.5, 1.5, 0.5, 2),
    whiteSpace: 'nowrap',
    zIndex: 10,
    display: 'inline-block',
    fontSize: '11px',
    clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%, 8px 50%)',
  },
}))
